import type { CopyShape } from "@tami/core/intl";

import type { INTERACTIVE_DEMO_COPY_PT_BR } from "../index.copy";

export const INTERACTIVE_DEMO_COPY_EN_US: CopyShape<typeof INTERACTIVE_DEMO_COPY_PT_BR> = {
  exploreOnYourOwn: "Explore the demo on your own",
};
